import React from "react";

// Marquee with infinite horizontal scroll. Pass `items` (array of strings).
const Marquee = ({ items, variant = "red", className = "", speed = "normal" }) => {
  const cls = speed === "slow" ? "marquee-track-slow" : "marquee-track";
  const repeated = [...items, ...items];
  const wrapBase =
    variant === "red"
      ? "bg-dc-red text-cream"
      : variant === "transparent"
      ? "bg-transparent text-cream border-y border-cream/20"
      : "bg-charcoal text-cream";

  return (
    <div
      data-testid={`marquee-${variant}`}
      className={`${wrapBase} overflow-hidden ${className}`}
    >
      <div className={`${cls} font-mono uppercase tracking-widest py-3 text-sm`}>
        {repeated.map((t, i) => (
          <span key={i} className="px-6 whitespace-nowrap inline-flex items-center">
            {t}
            <span className="mx-6 opacity-60">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
